import { render, h } from 'preact';
import "./TabBar.scss"
import Icon from "./Icon";
import { isIPX } from "../lib/helper";
import router from '../lib/router';

export default (props)=>{
    var { 
        activeTab = { type:"home" },
        onChangeTab = () => {},
        navs = {},
        activeType
    } = props;
    var {
        list = [
            {
                name:"首页",
                type:"home",
                icon:"md-bus",
                activeIcon:"md-bus",
            },
            {
                name:"零担快件",
                type:"order",
                icon:"md-paper-plane",
                activeIcon:"md-paper-plane",
            },
            {
                name:"历史",
                type:"history",
                icon:"md-list-box",
                activeIcon:"md-list-box"
            },
            {
                name:"商家中心",
                type:"stores",
                icon:"md-cube",
                activeIcon:"md-cube",
            },
            {
                name:"我的",
                type:"my",
                icon:"md-contact",
                activeIcon:"md-contact",
            }
        ],
        activeColor = "#0CBB08"
    } = navs;


    const handleChange = (data = {},index)=>{
        var { type } = data || {};
        // onChangeTab(data,index);
        type = type == "home" ? "index" : type; 
        if(type == "order") return router.go('order');
        if(type == "history") return router.go('history');
        if(type == "my") return router.go('my');
        // if(type == "stores") return router.go('stores?title='+encodeURIComponent('商城'));
        if(type == "stores") return router.go('store');
        wx.switchTab({url:`/pages/${type}/index`});
    }

    if(list.length == 0) return <div></div>;
    return (
    <div>
        <div className={`tabBarBlank ${isIPX ? "fixIPX" : ""}`} />
        <div className={`tabBar ${isIPX ? "fixIPX" : ""}`}>
            {list.map((data = {},index)=>{
                var { name,icon,activeIcon,type,url } = data;
                var isIcon = !(icon.indexOf("http") > -1);
                // var isActive = activeTab['type'] == type && activeTab['url'] == url;
                var isActive = activeType == type
                return(
                    <div key={index} 
                        className="phoneNavBar"
                        onclick={()=>{
                            handleChange(data,index);
                        }}
                        >
                        <div className="topIcon">
                            {!isIcon ?
                                <img src={isActive ? activeIcon : icon} className="img" /> :
                                <Icon 
                                    {...{icon:isActive ? activeIcon : icon}}
                                    style={{
                                        color:isActive ? activeColor : "#B2B2B2"
                                    }}
                                />
                            }
                        </div>
                        <span className="iconText" style={{
                            color:isActive ? activeColor : "#B2B2B2"
                        }}>{name}</span>
                    </div>
                );
            })}
        </div>
    </div>
    );
}